export default "__VITE_ASSET__Xn0UV5I8__"